import { render, staticRenderFns } from "./export-payment-batches.vue?vue&type=template&id=af37dfe2&"
import script from "./export-payment-batches.vue?vue&type=script&lang=js&"
export * from "./export-payment-batches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports